// Optimistic save: the look changes at once; if the server rejects it, put the old value back.
export async function saveAppearance({ value, previous, update, persist }) {
  update(value);
  try {
    await persist(value);
  } catch (err) {
    update(previous);
    throw err;
  }
}
